import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments.jsx";
import { arrayOfLabels } from "./schema.labels.jsx";

const task = new schema.Entity(`tasks`);
const arrayOfTasks = [task];

// task dependencies simulation
const rescheduleSimulationTask = new schema.Entity(`reschedule_simulation`);
const arrayOfRescheduleSimulationTasks = [rescheduleSimulationTask];

task.define({
  labels: arrayOfLabels,
  attachments: arrayOfAttachments,
});

export { task, arrayOfTasks, rescheduleSimulationTask, arrayOfRescheduleSimulationTasks };
